"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var react_1 = __importStar(require("react"));

var react_localization_1 = __importDefault(require("react-localization"));

var compositions_1 = require("../../compositions");

var json = __importStar(require("./localization.json"));

var ListItem = function ListItem(_a) {
  var item = _a.item,
      theme = _a.theme,
      language = _a.language;
  var localizedStrings = new react_localization_1["default"](json);
  localizedStrings.setLanguage((0, basic_frontend_common_1.getLanguage)());

  var _b = __read((0, react_1.useState)(), 2),
      isModalOpen = _b[0],
      setModalOpen = _b[1];

  var onDetailClicked = function onDetailClicked() {
    setModalOpen(isModalOpen ? false : true);
  };

  var source = "".concat(localizedStrings.searchContentAggregateList.listSource, ": ").concat(item.sourceName);
  return react_1["default"].createElement("li", {
    className: "border-b ".concat(theme ? theme.body.borderColor : "border-gray-800", " cursor-pointer"),
    onClick: onDetailClicked
  }, react_1["default"].createElement("div", {
    className: "flex flex-row justify-between items-center pt-6 pb-6 hover:bg-gray-100 hover:bg-opacity-25"
  }, react_1["default"].createElement("div", {
    className: "flex flex-col flex-grow mr-4 ml-4"
  }, react_1["default"].createElement(basic_frontend_common_1.TextLead, {
    theme: theme
  }, item.contentTitle), react_1["default"].createElement(basic_frontend_common_1.Comment, {
    theme: theme
  }, source)), !(0, basic_frontend_common_1.isMobileView)(768) && react_1["default"].createElement("div", {
    className: "mr-2 mt-2"
  }, react_1["default"].createElement(basic_frontend_common_1.ButtonRegular, {
    text: localizedStrings.searchContentAggregateList.listButtonDetails,
    onClick: onDetailClicked,
    type: basic_frontend_common_1.ButtonType.transparent,
    size: basic_frontend_common_1.ButtonSize.small,
    theme: theme
  }))), react_1["default"].createElement(compositions_1.ModalNews, {
    isModalOpen: isModalOpen,
    item: item,
    setModalOpen: setModalOpen,
    language: language,
    theme: theme
  }));
};

exports.ListItem = ListItem;